["ASIA", "ASIAXJ", "EM", "LATAM", "WOR"]
